<div class="dialog--informal dialog__container notification-dialog">
  <div class="dialog__content">
    <fa-icon class="dialog__icon notification-dialog__icon"
             role="img"
             [attr.aria-label]="label | translate"
             [class]="'dialog__icon notification-dialog__icon notification-dialog__icon--' + color"
             [icon]="data.DisplayType === 1 || data.Importance === 0 ? ['fas', 'circle-info'] : ['fas', 'circle-exclamation']">
    </fa-icon>
    <div class="dialog__message notification-dialog__message" [innerHTML]="data.Message"></div>
    <app-form-input *ngIf="data.DisplayType === 1 && data.InputType === 1"
                    class="notification-dialog__input"
                    [type]="FormInputType.Textarea"
                    [maxLength]="512"
                    [(ngModel)]="value">
    </app-form-input>
    <app-dropdown *ngIf="data.DisplayType === 1 && data.InputType === 2"
                  class="notification-dialog__input"
                  [options]="dropdownOptions"
                  [placeholder]="'webPos.Select' | translate"
                  [openOnKeyboardFocus]="false"
                  [(ngModel)]="value">
    </app-dropdown>
  </div>
  <div class="dialog__footer">
    <app-action-button [buttonType]="ActionButtonType.Primary" [disabled]="!valid" (clicked)="confirm()">
      {{ 'webPos.Ok' | translate }}
    </app-action-button>
  </div>
</div>
